import classNames from "classnames"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import {
  forwardRef,
  useMemo,
  useState,
} from "react"

import styles from "./Dropdown.module.scss"
import { DropdownContext } from "./DropdownContext"
import { DropdownOptionAttributesContextProvider } from "./DropdownOptionAttributesContextProvider"

export type Props = ComponentPropsWithoutRef<"div">

/*
 * this element wraps the select element so that our custom elements
 * can be properly aligned
 *
 * it also provides the relevant contexts for its children to use
 */
export const Dropdown = forwardRef<HTMLDivElement, Props>(
  function Dropdown(props: Props, propRef: Ref<HTMLDivElement>) {
    const [
      currentSelectionId,
      setCurrentSelectionId,
    ] = useState<string>()

    const value = useMemo(
      () => ({ setCurrentSelectionId }),
      [setCurrentSelectionId],
    )

    const className = classNames(
      props.className,
      styles.dropdown,
    )

    return (
      <DropdownContext.Provider value={value}>
        <DropdownOptionAttributesContextProvider currentSelectionId={currentSelectionId} >
          <div
            {...props}
            ref={propRef}
            className={className}
          >
            {props.children}
          </div>
        </DropdownOptionAttributesContextProvider>
      </DropdownContext.Provider>
    )
  },
)
